import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { VisitorsList } from "../views/VisitorsList";
import CamerasList from "../views/Cameras/CamerasList";
import { Layout } from "../components/Layout";
import EstablishmentHashList from "../views/EstablishmentHashList";
import { AnalyticsReportV2 } from "../views/AnalyticsReporter/AnalyticsReportV2";
import { NotFound } from "../views/NotFound";
import ListSystemUser from "../views/SystemUser/ListSystemUser";
import { SystemUserForm } from "../views/SystemUser/SystemUserForm";
import { EstablishmentForm } from "../views/Establishment/EstablishmentForm";
// import CameraDetils from "../views/Cameras/CameraDetails";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { ADMIN_ROLES, GLOBAL_ROLES } from "../constants/roles";
import Dashboard from "../views/Dashboard";
import LiveStreams from "../views/LiveStreams";
import { SubscriptionsDashboard } from "../views/Subscriptions/Dashboard";
import { AuditLogs } from "../views/AuditLogs";
import YoutubeAccounts from "../views/YoutubeAccounts";
import Help from "../views/Help";

const CameraDetails = lazy(() => import("../views/Cameras/CameraDetails"));
const CameraVideos = lazy(() => import("../views/Cameras/CameraVideos"));
const CameraLogos = lazy(() => import("../views/Cameras/CameraLogos"));
const CameraPrivate = lazy(() => import("../views/Cameras/CameraPrivate"));
const LiveWorkspace = lazy(() => import("../views/LiveStreams/LiveWorkspace"));
const LiveTabRedirect = lazy(() => import("../views/LiveStreams/LiveTabRedirect"));

export function AppRoutes() {
  return (
    <Layout>
      <Suspense
        fallback={
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress size={28} />
          </Box>
        }
      >
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/estabelecimentos"
          element={<Navigate to="/cameras" replace />}
        />
        <Route path="/estabelecimento/:id" element={<EstablishmentForm />} />
        <Route path="/cameras" element={<CamerasList />} />
        <Route path="/transmissoes-ao-vivo" element={<LiveStreams />} />
        <Route path="/transmissoes-ao-vivo/live/:liveId" element={<LiveWorkspace />} />
        {/* Old per-screen URLs kept as redirects into the unified workspace so bookmarked/emailed links keep working. */}
        {/* The id-less draft-payment flow this route used to serve no longer exists (new lives are
            created with a real id up front, see LiveStreams/index.tsx), so a stale bookmark to it
            can only be sent back to the lives list instead of a specific workspace tab. */}
        <Route
          path="/transmissoes-ao-vivo/pagamento"
          element={<Navigate to="/transmissoes-ao-vivo" replace />}
        />
        <Route
          path="/transmissoes-ao-vivo/pagamento/:liveId"
          element={<LiveTabRedirect tab="pagamento" />}
        />
        <Route path="/transmissoes-ao-vivo/link/:liveId" element={<LiveTabRedirect tab="branding" />} />
        <Route path="/transmissoes-ao-vivo/admin/:liveId" element={<LiveTabRedirect tab="detalhes" />} />
        <Route
          path="/transmissoes-ao-vivo/detalhes/:liveId"
          element={<LiveTabRedirect tab="detalhes" />}
        />
        <Route path="/transmissoes-ao-vivo/placar/:liveId" element={<LiveTabRedirect tab="placar" />} />
        <Route element={<ProtectedRoute allowedRoles={GLOBAL_ROLES} />}>
          <Route path="/estabelecimento/new" element={<EstablishmentForm />} />
          <Route path="/reporter" element={<AnalyticsReportV2 />} />
          <Route path="/visitantes" element={<VisitorsList />} />
          <Route path="/settings/links" element={<EstablishmentHashList />} />
          <Route path="/analytics-reporter" element={<Navigate to="/reporter" replace />} />
          <Route path="/usuarios" element={<ListSystemUser />} />
          <Route path="/usuario" element={<SystemUserForm />} />
          <Route path="/usuario/new" element={<SystemUserForm />} />
          <Route path="/usuario/:id" element={<SystemUserForm />} />
          <Route path="/youtube-contas" element={<YoutubeAccounts />} />
          <Route path="/ajuda" element={<Help />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={ADMIN_ROLES} />}>
          <Route path="/assinaturas" element={<SubscriptionsDashboard />} />
          <Route path="/auditoria" element={<AuditLogs />} />
        </Route>
        <Route
          path="/cameras/:establishmentId/:id"
          element={<CameraDetails />}
        />
        <Route
          path="/cameras/:establishmentId/:id/videos"
          element={<CameraVideos />}
        />
        <Route
          path="/cameras/:establishmentId/:id/logos"
          element={<CameraLogos />}
        />
        <Route
          path="/cameras/:establishmentId/:id/private"
          element={<CameraPrivate />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </Suspense>
    </Layout>
  );
}
